import { Action, State, StateContext } from '@ngxs/store'
import { Injectable } from '@angular/core'
import { UpdateTagEditorValidation } from '../actions/tag-editor-validation.actions'

export interface TagEditorValidationStateModel {
  readonly hasTags: boolean
  readonly isValid: boolean
  readonly lastUpdated: number
}

@State<TagEditorValidationStateModel>({
  name: 'tagEditorValidation',
  defaults: {
    hasTags: false,
    isValid: false,
    lastUpdated: 0,
  },
})
@Injectable()
export class TagEditorValidationState {
  @Action(UpdateTagEditorValidation)
  updateTagEditorValidation(ctx: StateContext<TagEditorValidationStateModel>, action: UpdateTagEditorValidation): void {
    const isValid = action.hasTags

    ctx.patchState({
      hasTags: action.hasTags,
      isValid: isValid,
      lastUpdated: Date.now(),
    })
  }
}
